<template>
  <div class="d-flex justify-content" id="link-form-login">
    <router-link to="/esqueci-senha" class="col-6">Alterar senha?</router-link>
  </div>
</template>

<script>
export default {
  name: "LinksFormLogin",
};
</script>

<style scoped>

#link-form-login a {
  padding: 0px;
  margin: 0px;
  line-height: 1.5;
  letter-spacing: 0;
  font-family: optum-sans;
  font-weight: 400;
  font-size: 0.875rem;
  color: rgb(90, 90, 90);
  text-align: right;
  white-space: nowrap;
}

#link-form-login div {
  display: flex;
  align-items: flex-end;
  padding-left: 20px;
}
</style>